<div class="row">
    <div class="col-xl-4">
        <div class="card widget-1">
            <div class="card-body">
                <div class="widget-content">
                    <div class="widget-round {{personaActiva.font}}">
                        <div class="bg-round">
                             <svg class="svg-fill">
             <use attr.xlink:href="assets/svg/icon-sprite.svg#{{personaActiva.icon}}"></use>
           </svg> 
                            <svg class="half-circle svg-fill">
                                <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
                            </svg>
                        </div>
                    </div>
                    <div>
                       <h4>{{personaActiva.counter}}</h4>
                        <span class="f-light">{{personaActiva.name}}</span>
                    </div>
                </div>
                <div class="font-success f-w-500"><i class="icofont icofont-arrow-right me-1"></i><span>{{personaActiva.pr}}%</span></div>
            </div>

        </div>
    </div>
    <div class="col-xl-4">
        <div class="card widget-1">
            <div class="card-body">
                <div class="widget-content">
                    <div class="widget-round {{personaInactiva.font}}">
                        <div class="bg-round">
                            <svg class="svg-fill">
                                <use attr.xlink:href="assets/svg/icon-sprite.svg#{{personaInactiva.icon}}"></use>
                            </svg>
                            <svg class="half-circle svg-fill">
                                <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
                            </svg>
                        </div>
                    </div>
                    <div>
                        <h4>{{personaInactiva.counter}}</h4>
                        <span class="f-light">{{personaInactiva.name}}</span>
                    </div>
                </div>
                <div class="font-{{personaInactiva.font}} f-w-500"><i
                        class="icofont icofont-arrow-right me-1"></i><span>{{personaInactiva.pr}}%</span></div>
            </div>
    
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card widget-1">
            <div class="card-body">
                <div class="widget-content">
                    <div class="widget-round {{personaTotal.font}}">
                        <div class="bg-round">
                            <svg class="svg-fill">
                                <use attr.xlink:href="assets/svg/icon-sprite.svg#{{personaTotal.icon}}"></use>
                            </svg>
                            <svg class="half-circle svg-fill">
                                <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
                            </svg>
                        </div>
                    </div>
                    <div>
                        <h4>{{personaTotal.counter}}</h4>
                        <span class="f-light">{{personaTotal.name}}</span>
                    </div>
                </div>
                <div class="font-{{personaTotal.font}} f-w-500"><i
                        class="icofont icofont-arrow-right me-1"></i><span>{{personaTotal.pr}}%</span></div>
            </div>
    
        </div>
    </div>
</div>
<div class="row">
    <div class="col-xl-4">
        <div class="card widget-1">
            <div class="card-body">
                <div class="widget-content">
                    <div class="widget-round {{vehActivos.font}}">
                        <div class="bg-round">
                             <svg class="svg-fill">
             <use attr.xlink:href="assets/svg/icon-sprite.svg#{{vehActivos.icon}}"></use>
           </svg> 
                            <svg class="half-circle svg-fill">
                                <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
                            </svg>
                        </div>
                    </div>
                    <div>
                       <h4>{{vehActivos.counter}}</h4>
                        <span class="f-light">{{vehActivos.name}}</span>
                    </div>
                </div>
                <div class="font-success f-w-500"><i class="icofont icofont-arrow-right me-1"></i><span>{{vehActivos.pr}}%</span></div>
            </div>

        </div>
    </div>
    <div class="col-xl-4">
        <div class="card widget-1">
            <div class="card-body">
                <div class="widget-content">
                    <div class="widget-round {{vehInactivos.font}}">
                        <div class="bg-round">
                            <svg class="svg-fill">
                                <use attr.xlink:href="assets/svg/icon-sprite.svg#{{vehInactivos.icon}}"></use>
                            </svg>
                            <svg class="half-circle svg-fill">
                                <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
                            </svg>
                        </div>
                    </div>
                    <div>
                        <h4>{{vehInactivos.counter}}</h4>
                        <span class="f-light">{{vehInactivos.name}}</span>
                    </div>
                </div>
                <div class="font-{{vehInactivos.font}} f-w-500"><i
                        class="icofont icofont-arrow-right me-1"></i><span>{{vehInactivos.pr}}%</span></div>
            </div>
    
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card widget-1">
            <div class="card-body">
                <div class="widget-content">
                    <div class="widget-round {{vehTotal.font}}">
                        <div class="bg-round">
   
                            <svg class="svg-fill">
                                <use attr.xlink:href="assets/svg/icon-sprite.svg#{{vehTotal.icon}}"></use>
                            </svg>
                            <svg class="half-circle svg-fill">
                                <use href="assets/svg/icon-sprite.svg#halfcircle"></use>
                            </svg>
                        </div>
                    </div>
                    <div>
                        <h4>{{vehTotal.counter}}</h4>
                        <span class="f-light">{{vehTotal.name}}</span>
                    </div>
                </div>
                <div class="font-{{vehTotal.font}} f-w-500"><i
                        class="icofont icofont-arrow-right me-1"></i><span>{{vehTotal.pr}}%</span></div>
            </div>
    
        </div>
    </div>
</div>

